
import styles from '../style.module.css';
import React from "react";
import { useSelector } from "react-redux";
import CustomVideo from './CustomVideo';
import normalizeAboutHtml from '../normalizeAboutHtml';

const ABOUT_YOUTUBE_IDS = {
    hy: "vL-bAjZkwjQ",
    ru: "aWpBK3eb7fU",
    en: "aWpBK3eb7fU",
};

export default function VideoSection({data}) {
    const { currentLanguage } = useSelector(({ main }) => main);
    const youtubeId = ABOUT_YOUTUBE_IDS[currentLanguage] || ABOUT_YOUTUBE_IDS.hy;

    return (
        <div className = { styles.video_container }>
            <CustomVideo youtubeId={youtubeId} />
            <div
                className={styles.video_text}
                dangerouslySetInnerHTML={{
                    __html: normalizeAboutHtml(data),
                }}
            />
        </div>
    )
}
